import { computed, ref } from 'vue'

import {
  useUpdateAccountTitleMutation,
  type User,
} from '@/shared/graphql/legacy/generated'
import { ToastType, useToastStore } from '@/shared/stores/toast'
import { NativeActionsEnum, useWebviewStore } from '@/shared/stores/webview'

export function useChangeTitle(user: User) {
  const toastStore = useToastStore()
  const webviewStore = useWebviewStore()

  const title = ref(user.title || '')

  const { mutate: updateAccountTitle, loading } =
    useUpdateAccountTitleMutation()

  const canSave = computed(
    () => title.value.trim() !== (user.title || '').trim()
  )

  const save = async () => {
    if (!canSave.value) return false

    updateAccountTitle(
      { title: title.value },
      {
        optimisticResponse: {
          __typename: 'Mutation',
          updateAccountTitle: {
            __typename: 'User',
            id: user.id,
            title: title.value,
          },
        },
        update() {
          if (!webviewStore.isActive) return

          webviewStore.postMessage({
            type: NativeActionsEnum.UserUpdated,
            data: { user: { ...user, title: title.value } },
          })
        },
      }
    )

    toastStore.showToast({
      type: ToastType.Success,
      content: 'Your title has been updated',
    })

    return true
  }

  return { title, loading, canSave, save }
}
